export function subMenuBtn() {
  // Find the class to add a button to
  const addSubMenuBtn = document.querySelectorAll(".menu-item-has-children");

  for (let i = 0; i < addSubMenuBtn.length; i++) {
    // Create button and icon elements
    const newBtn = document.createElement("button");
    const icon = document.createElement("i");
    // Add classes to the elements
    newBtn.classList.add("submenu-btn");
    icon.classList.add("icon");
    icon.classList.add("icon-chevon-down");
    // Insert icon into button
    newBtn.appendChild(icon);

    // Insert complete button underneath class
    addSubMenuBtn[i].appendChild(newBtn);
  }

  // Add is-active on click of a Sub Menu Button
  var all_items = document.querySelectorAll(".submenu-btn");

  Array.from(all_items).forEach((per_item) => {
    per_item.addEventListener("click", function () {
      this.previousElementSibling.classList.toggle("is-active");
      this.classList.toggle("is-active");
    });
  });
}
